import { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { patchInvestigation } from "../../../../../apis";
import { InvestigationSectionHeader } from "../components/InvestigationSectionHeader";
import { InvestigationAdvertisement } from "../components/InvestigationAdvertisement";
import { AddResource } from "./AddResource";
import { ResourceTypes } from "./ResourceTypes";
import { initResources } from "./schemas";
import { Separator } from "../components";
import { useConstants } from "../Main/useConstants";

export const Resources = ({
  investigation,
  setInvestigation,
  justView,
  handleSelectedSection,
  openConfirmDeleteModal,
  closeModalConfirm,
}) => {
  const {
    enums,
    functions: { askUpdateInvestigationContext },
  } = useConstants();
  const [t] = useTranslation("investigation");
  const [resources, setResources] = useState(
    investigation?.resources ?? _.cloneDeep(initResources),
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedResource, setSelectedResource] = useState(null);

  useEffect(() => {
    if (investigation?.resources != null) {
      setResources(investigation.resources);
    } else {
      setResources(_.cloneDeep(initResources));
    }
  }, [investigation]);

  const haveResources = useMemo(() => {
    let exist = false;
    Object.values(resources).map((value) => {
      if (Array.isArray(value) && value.length > 0) {
        exist = true;
      }
    });
    return exist;
  }, [resources]);

  const handleSaveResources = async (newResources) => {
    setIsLoading(true);
    const objToSave = {
      folder: {
        resources: newResources,
      },
    };
    try {
      await patchInvestigation(investigation.alias, objToSave);
      setInvestigation({ ...investigation, resources: newResources });
      askUpdateInvestigationContext({
        ...investigation,
        resources: newResources,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box className="dyTheme1" p={1}>
      {!isEditing && !justView && (
        <InvestigationSectionHeader
          text={t("resources.add_resource_to_investigation")}
          buttonText={t("resources.add_resource")}
          buttonIcon="outline_origin_search"
          onClick={() => setIsEditing(true)}
        />
      )}

      {justView && (
        <Separator
          text={t("resources.resources")}
          icon="outline_origin_search"
          iconButton={handleSelectedSection ? "outline_edit" : undefined}
          onClick={
            handleSelectedSection
              ? () => handleSelectedSection(enums.sections.resources)
              : undefined
          }
          sx={{ marginBottom: 1.5 }}
        />
      )}

      {!haveResources && !isEditing && (
        <InvestigationAdvertisement
          title={t("resources.advertisement_title")}
          description={t("resources.advertisement_description")}
        />
      )}

      {haveResources && !isEditing && (
        <ResourceTypes
          resources={resources}
          handleSaveResources={handleSaveResources}
          setSelectedResource={setSelectedResource}
          setIsEditing={setIsEditing}
          isLoading={isLoading}
          justView={justView}
          openConfirmDeleteModal={openConfirmDeleteModal}
          closeModalConfirm={closeModalConfirm}
        />
      )}

      {isEditing && (
        <AddResource
          resources={resources}
          handleSaveResources={handleSaveResources}
          selectedResource={selectedResource}
          setSelectedResource={setSelectedResource}
          isLoading={isLoading}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
        />
      )}
    </Box>
  );
};
